export default function formattedDateTime(dateTime: string): string {
  return new Date(dateTime).toLocaleString('ru-RU', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
